import * as Utils from '../lib/savanna_utils.js';
import * as SystemEvents from '../lib/system_events.js';
import completeFunctionsAfterLogin from '../lib/after_login.js';
import * as Navbar from '../lib/update_navbar_notifications.js';

class GrapeUIPlugin
{
	constructor(Grape, options)
	{
		this.Grape = Grape;
		this.options = options;
		this.userCanApproveLeave = true;
	}

	afterInit()
	{
		const el = document.getElementsByClassName('ps-navbar-container')[0];
		ko.applyBindings({}, el);
		
	}

	async beforeNavbarRender() {
		//await Utils.refresh_data_visible_roles();
	}

	async afterNavbarRender(navbar)
	{
		//await Utils.refresh_data_visible_roles();
		if (Grape.currentSession?.user?.username)
			$('#username_login').html(this.Grape.currentSession.user.username);
		Utils.setCompanyDisplayName();
		Utils.set_language_phrases()
		Utils.set_username();
		
	}

	async onSessionChange(session)
	{
		if (session)
		{
			await completeFunctionsAfterLogin();
			Utils.setProfileLink();
			$('#username_login').html(session.user.username);
			this.userCanApproveLeave = true;
		}
		else
		{
			await Utils.refresh_data_visible_roles();
			this.userCanApproveLeave = false;
		}
	}

	async beforePageLoad()
	{
		
		Utils.set_language_phrases()
		Utils.set_username();
		Utils.addLoaderToPage();
		Utils.showLoader();
		
	}

	async afterPageLoad()
	{
		
		Utils.hideLoader();
		if (window.Grape.currentSession)
		{
			Navbar.updateSystemCount();
			Navbar.updateLeaveRequestCount();
			Navbar.updateNotificationCount();
			Navbar.updateWizardNotDoneCount();
			Navbar.updateTimeToApproveCount();

			Utils.set_language_phrases()
			Utils.set_username()
			
		}
		await Utils.refresh_data_visible_roles();
	}
}

export default GrapeUIPlugin;